import { format, formatDistanceToNow, parseISO } from "date-fns";

export const STATUS_STYLES = {
  up: "bg-emerald-50 text-emerald-700 border-emerald-200",
  down: "bg-rose-50 text-rose-700 border-rose-200",
  warn: "bg-amber-50 text-amber-700 border-amber-200",
  unknown: "bg-slate-100 text-slate-600 border-slate-300",
};

export const DOT_STYLES = {
  up: "bg-emerald-500",
  down: "bg-rose-500",
  warn: "bg-amber-500",
  unknown: "bg-slate-400",
};

export const CHART_COLORS = {
  up: "#10B981",
  down: "#F43F5E",
  warn: "#F59E0B",
  unknown: "#94A3B8",
  brand: "#2563EB",
};

export function siteVariant(status) {
  if (status === "UP") return "up";
  if (status === "DOWN") return "down";
  return "unknown";
}

export function siteDisplay(site) {
  if (site?.paused) return { variant: "unknown", label: "PAUSED" };
  return { variant: siteVariant(site?.status), label: site?.status || "UNKNOWN" };
}

export function sslVariant(ssl) {
  if (!ssl || ssl.status === "UNKNOWN") return "unknown";
  return ssl.status === "ACTIVE" ? "up" : ssl.status === "EXPIRING" ? "warn" : "down";
}

export function domainVariant(d) {
  if (!d || d.status === "UNKNOWN") return "unknown";
  return d.status === "ACTIVE" ? "up" : d.status === "EXPIRING" ? "warn" : "down";
}

export function dnsVariant(dns) {
  if (!dns || !dns.status) return "unknown";
  return dns.status === "No Changes" ? "up" : "warn";
}

export function perfVariant(p) {
  if (!p || p.status === "UNKNOWN") return "unknown";
  return p.status === "GOOD" ? "up" : p.status === "AVERAGE" ? "warn" : "down";
}

export function securityVariant(http) {
  if (!http || http.security_score == null) return "unknown";
  const s = http.security_score;
  return s >= 5 ? "up" : s >= 3 ? "warn" : "down";
}

export function redirectVariant(http) {
  if (!http || !http.http_to_https) return "unknown";
  const st = http.http_to_https.status;
  return st === "OK" ? "up" : st === "FAIL" ? "down" : "unknown";
}

export const SECURITY_HEADER_LABELS = {
  hsts: "HSTS (Strict-Transport-Security)",
  csp: "Content-Security-Policy",
  x_frame_options: "X-Frame-Options",
  x_content_type_options: "X-Content-Type-Options",
  referrer_policy: "Referrer-Policy",
  permissions_policy: "Permissions-Policy",
};

export function fmtMs(v) {
  return v == null ? "—" : `${v} ms`;
}

export function fmtPct(v) {
  return v == null ? "—" : `${v}%`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return format(parseISO(iso), "d MMM yyyy, h:mm a");
  } catch {
    return iso;
  }
}

export function fmtDay(iso) {
  if (!iso) return "—";
  try {
    return format(parseISO(iso), "d MMM yyyy");
  } catch {
    return iso;
  }
}

export function timeAgo(iso) {
  if (!iso) return "never";
  try {
    return formatDistanceToNow(parseISO(iso), { addSuffix: true });
  } catch {
    return "—";
  }
}

export function fmtDuration(seconds) {
  if (seconds == null) return "ongoing";
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m < 60) return `${m}m ${s}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}
